import { useState } from 'react';
import { Link } from 'react-router-dom';
import { questions } from '../config/data';
import Card from './Card';
import { BiSolidLeftArrow } from "react-icons/bi";
import { BiSolidRightArrow } from "react-icons/bi";
const Questions = () => {
  const ITEMS_PER_PAGE = 5; // Number of items per page
  const [currentPages, setCurrentPages] = useState(
    Object.keys(questions).reduce((acc, key) => {
      acc[key] = 0; // Initialize page 0 for each question set
      return acc;
    }, {})
  );

  // Handler to update the current page for a specific question set
  const setPageForSet = (qSetKey, page) => {
    setCurrentPages((prev) => ({
      ...prev,
      [qSetKey]: page,
    }));
  };

  return (
    <div className="questions-wrapper">
      {Object.keys(questions).map((qSetKey) => {
        const { id, icon, title, list } = questions[qSetKey];
        const currentPage = currentPages[qSetKey];
        const totalPages = Math.ceil(list.length / ITEMS_PER_PAGE);

        // Get items for the current page
        const currentItems = list.slice(
          currentPage * ITEMS_PER_PAGE,
          (currentPage + 1) * ITEMS_PER_PAGE
        );

        return (
          <Card id= {qSetKey} className={`questions-card ${qSetKey}`}  key={id} >
            <div className='card-header icon-header'>
              <h3>{title}</h3>
              <span>{icon}</span>
            </div>
            <ul className="question-list">
              {currentItems.map((question) => (
                <li className="question-item" key={question.id}>
                  <Link to={`/game/${qSetKey}/${question.title}`}>
                    {question.title}
                  </Link>
                  <small className='question-info'>{question.info}</small>
                </li>
              ))}
            </ul>

            {/* Pagination Controls */}
            {list.length > ITEMS_PER_PAGE && (
              <div className="pagination-controls">
                <button
                  onClick={() => setPageForSet(qSetKey, currentPage - 1)}
                  disabled={currentPage === 0}
                  className="arrow-btn btn"
                >
                  <i className="icon"><BiSolidLeftArrow/></i>
                </button>
                <span>
                  {currentPage + 1} - {totalPages}
                </span>
                <button
                  onClick={() => setPageForSet(qSetKey, currentPage + 1)}
                  disabled={currentPage === totalPages - 1}
                  className="arrow-btn btn"
                >
                  <i className="icon"><BiSolidRightArrow/></i>
                </button>
              </div>
            )}
          </Card>
        );
      })}
    </div>
  );
};

export default Questions;
